/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import Card from '@bottlebooks/gatsby-design-system/src/components/Card/Card';
import React from 'react';
import { jsx } from 'theme-ui';
import BaseExhibitorCard from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsList/ExhibitorCard';
import ExhibitorMedals from './ExhibitorMedals';

export * from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsList/ExhibitorCard';

/**
 *
 * @param {object} props
 * @param {object} props.exhibitor
 * @param {string} [props.to]
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 * @param {Parameters<Card>[0]["elevation"]} [props.elevation]
 * @param {React.MouseEventHandler} [props.onClick]
 * @param {React.ReactNode} [props.children]
 * @returns
 */
export default function ExhibitorCard({
  exhibitor,
  className,
  style,
  elevation,
  children,
  ...rest
}) {
  return (
    <BaseExhibitorCard.Card
      // The styles are applied to the Card component, not the Link component.
      className={className}
      style={style}
      elevation={elevation}
    >
      <BaseExhibitorCard.Link exhibitor={exhibitor} {...rest}>
        <ExhibitorMedals
          medaillen={exhibitor.medaillen}
          sx={{ width: '100%', marginTop: 2.5, paddingRight: 4 }}
        />
        <BaseExhibitorCard.Logo exhibitor={exhibitor} />
        <BaseExhibitorCard.Main exhibitor={exhibitor}>
          <BaseExhibitorCard.Exhibitor exhibitor={exhibitor} />
          <BaseExhibitorCard.Characteristics exhibitor={exhibitor} />
          {children}
        </BaseExhibitorCard.Main>
      </BaseExhibitorCard.Link>
      <BaseExhibitorCard.Bookmark exhibitor={exhibitor} />
    </BaseExhibitorCard.Card>
  );
}
ExhibitorCard.Card = Card;
ExhibitorCard.Link = BaseExhibitorCard.Link;
ExhibitorCard.Bookmark = BaseExhibitorCard.Bookmark;
ExhibitorCard.Logo = BaseExhibitorCard.Logo;
ExhibitorCard.Main = BaseExhibitorCard.Main;
ExhibitorCard.Exhibitor = BaseExhibitorCard.Exhibitor;
ExhibitorCard.Characteristics = BaseExhibitorCard.Characteristics;
